import { Component, computed, inject, input } from '@angular/core';
import { NodeProam } from '@app/models/entity.model';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { ProductLayoutComponent } from '@app/components/product/product-layout/product-layout.component';
import { MobiLdSchemaComponent } from '@app/components/mobi-ld-schema/mobi-ld-schema.component';
import { ContentLinkService } from '@app/services/contentLinks.service';

@Component({
  selector: 'mobi-node-proam',
  templateUrl: './node-proam.component.html',
  styleUrls: ['./node-proam.component.scss'],
  standalone: true,
  imports: [EntitySharedModule, ProductLayoutComponent, MobiLdSchemaComponent],
})
export class NodeProamComponent {
  readonly entity = input.required<NodeProam>();
  schema = computed(() => this.entity().schemaOrg);

  #contentLink = inject(ContentLinkService);

  contentLinks = computed<any>(() => {
    const paragraphs = this.entity()?.paragraphs;
    return this.#contentLink.getContentLinks(paragraphs);
  });
}
